import React, { useState } from "react";
import { useEffect } from "react";
import "./adminmaincontainer.css";

import { Bar } from "react-chartjs-2";
import axios from "axios";
import { FaTwitter, FaInstagram, FaFacebook } from "react-icons/fa";
import { BsTiktok } from "react-icons/bs";
import ApexCharts from "react-apexcharts"; // Import the ApexCharts component
import { format } from "date-fns";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const formatDate = (date) => {
  return format(new Date(date), "d MMM yyyy"); // Format to "2 Mar 2025"
};
const AdminMainContainer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [logs, setLogs] = useState([]);

  const handleFromDateChange = (e) => {
    const newDate = e.target.value;
    setFromDate(newDate);
  };
  const handleToDateChange = (e) => {
    const newDate = e.target.value;
    setToDate(newDate);
  };

  // const [isLoading, setIsLoading] = useState(false);

  // Right-side states for user inputs
  const getLast24Hours = () => {
    const now = new Date();
    const last24Hours = new Date(now.getTime() - 24 * 60 * 60 * 1000);

    return {
      from:
        last24Hours.getFullYear() +
        "-" +
        String(last24Hours.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(last24Hours.getDate()).padStart(2, "0"),

      to:
        now.getFullYear() +
        "-" +
        String(now.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(now.getDate()).padStart(2, "0"),
    };
  };

  // ✅ Initialize state with last 24 hours
  const [fromDate, setFromDate] = useState(() => getLast24Hours().from);
  const [toDate, setToDate] = useState(() => getLast24Hours().to);

  // ✅ Ensure date updates correctly when component mounts
  useEffect(() => {
    const { from, to } = getLast24Hours();
    setFromDate(from);
    setToDate(to);
  }, []);

  const [rightSidePlatform, setRightSidePlatform] = useState([
    "Twitter",
    "Instagram",
    "Facebook",
    "TikTok",
  ]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [logsPerPage] = useState(15);
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "donut", // Set chart type to "donut"
      },
      labels: ["Used Mentions", "Remaining Mentions"], // Labels for the donut chart
      colors: ["#1DA1F2", "#E1306C"],


      // Custom colors for the slices
      plotOptions: {
        pie: {
          donut: {
            size: "70%", // Size of the donut hole
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => {
          if (val >= 1000000) return (val / 1000000).toFixed(1) + "M"; // Convert to millions
          if (val >= 1000) return (val / 1000).toFixed(1) + "K"; // Convert to thousands
          return val.toFixed(0); // Return original number if less than 1000
        },
        style: {
          fontSize: "14px",
          fontWeight: "bold",
        },
      },

      legend: {
        position: "bottom",
        horizontalAlign: "center",
      },
      title: {
        text: "Mentions Overview",
        align: "center",
        style: {
          fontSize: "16px",
        },
      },
    },
  });

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + "M"; // Convert to millions
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + "K"; // Convert to thousands
    }
    return num.toString(); // Return original number if less than 1000
  };

  const [barChartData, setBarChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "bar",
        height: 450, // Keep the height
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
        },
      },
      xaxis: {
        categories: ["Twitter", "Instagram", "Facebook", "TikTok"],
        title: { text: "Platforms" },
      },
      yaxis: {
        title: { text: "Mentions Count" },
      },
      colors: [
        "black", // Twitter
        "#C13584", // Instagram
        "#1877F2", // Facebook
        "rgba(147, 0, 199, 0.9)", // TikTok
      ],

      // ✅ FIXED: Use Relative Paths for Local Images
      annotations: {
        images: [
          {
            x: 0.5,
            y: 50,
            width: 30,
            height: 30,
            appendTo: "chart",
          },
          {
            x: 1.5,
            y: 50,
            width: 30,
            height: 30,
            appendTo: "chart",
          },
          {
            x: 2.5,
            y: 50,
            width: 30,
            height: 30,
            appendTo: "chart",
          },
          {
            x: 3.5,
            y: 50,
            width: 30,
            height: 30,
            appendTo: "chart",
          },
        ],
      },
    },
  });



  const fetchLogs = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get("api/logs/");
      console.log("Fetched Logs Data:", response.data); // Log the entire response data
      setLogs(
        response.data.data.sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        )
      );
    } catch (error) {
      console.error(
        "Error fetching logs:",
        error.response ? error.response.data : error
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs(); // Fetch logs immediately when page loads

    const interval = setInterval(() => {
      fetchLogs(); // Auto-refresh logs every 30 seconds
    }, 30000); // Adjust the time if needed

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  useEffect(() => {
    if (rightSidePlatform.length > 0) {
      handleShowMentionsClick(); // Automatically fetch mentions on page load
    }
  }, [rightSidePlatform]); // Runs when the component mounts or when platforms are updated



  const filteredLogs = logs.filter((log) => {
    return (
      (log.username &&
        log.username.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (log.accessed_module &&
        log.accessed_module
          .toLowerCase()
          .includes(searchQuery.toLowerCase())) ||
      (log.action &&
        log.action.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  });

  // Pagination logic
  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = filteredLogs.slice(indexOfFirstLog, indexOfLastLog);

  const totalPages = Math.ceil(filteredLogs.length / logsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const downloadLogs = () => {
    const csvData = filteredLogs.map((log) => ({
      ID: log.id,
      Username: log.username,
      "IP Address": log.ip_address,
      "Accessed Module": log.accessed_module,
      Action: log.action,
      Timestamp: new Date(log.timestamp).toLocaleString(),
    }));

    const csvRows = [
      [
        "ID",
        "Username",
        "IP Address",
        "Accessed Module",
        "Action",
        "Timestamp",
      ], // Header
      ...csvData.map((log) => [
        log.ID,
        log.Username,
        log["IP Address"],
        log["Accessed Module"],
        log.Action,
        log.Timestamp,
      ]),
    ];

    const csvContent =
      "data:text/csv;charset=utf-8," +
      csvRows.map((row) => row.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "logs.csv");
    document.body.appendChild(link);
    link.click();
  };

  const handlePlatformChange = (e, platform) => {
    if (platform === "All") {
      if (e.target.checked) {
        setRightSidePlatform(["Twitter", "Instagram", "Facebook", "TikTok"]);
      } else {
        setRightSidePlatform([]);
      }
    } else {
      if (e.target.checked) {
        setRightSidePlatform((prevPlatforms) => [...prevPlatforms, platform]);
      } else {
        setRightSidePlatform((prevPlatforms) =>
          prevPlatforms.filter((p) => p !== platform)
        );
      }
    }
  };

  const fetchMentionsData = async (platforms, fromDate, toDate) => {
    try {
      console.log("🔍 Sending API Request with Params:");
      console.log("➡️ Platforms:", platforms);
      console.log("➡️ From Date:", fromDate);
      console.log("➡️ To Date:", toDate);

      if (!platforms.length || !fromDate || !toDate) {
        console.error("❌ Missing required parameters for API request.");
        return;
      }

      const response = await axios.post("api/mentions/", {
        platforms: platforms,
        from_date: fromDate,
        to_date: toDate,
      });

      console.log("✅ API Response Data:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Error fetching mentions data:",
        error.response ? error.response.data : error
      );
      throw error;
    }
  };

  const [usedMentions, setUsedMentions] = useState(0);
  const [totalMentions, setTotalMentions] = useState(1000); // Default total mentions
  const coinTypes = ["xt", "Fw3P", "VoNl", "W9jz"]; // Available coin types

  const [selectedCoin, setSelectedCoin] = useState(() => {
    return coinTypes[Math.floor(Math.random() * coinTypes.length)]; // Select a random coin on page load
  });

  // Coin URLs
  const coinImages = {
    xt: "https://i.gifer.com/xt.gif",
    Fw3P: "https://i.gifer.com/Fw3P.gif",
    VoNl: "https://i.gifer.com/VoNl.gif",
    W9jz: "https://i.gifer.com/W9jz.gif",
  };

  const generateDailyMentions = (platformTotals, startDate, endDate) => {
    let dailyMentions = [];

    // Convert startDate & endDate to Date objects
    let start = new Date(startDate);
    let end = new Date(endDate);
    let totalDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24)); // Calculate number of days

    if (totalDays <= 0) {
      console.error("❌ Invalid date range.");
      return [];
    }

    // Generate date labels (YYYY-MM-DD)
    let dates = [];
    let currentDate = new Date(start);
    while (currentDate <= end) {
      dates.push(currentDate.toISOString().split("T")[0]); // Format YYYY-MM-DD
      currentDate.setDate(currentDate.getDate() + 1);
    }

    console.log("📅 Extracted Days:", dates);

    // Process each platform
    Object.entries(platformTotals).forEach(([platform, totalMentions]) => {
      console.log("Platform Data Processed:", platform, totalMentions);

      let avgPerDay = totalMentions / totalDays;

      let dailyData = dates.map((date) => ({
        x: date,
        y: Math.round(avgPerDay + Math.random() * avgPerDay * 0.2), // Add slight variations
      }));

      dailyMentions.push({
        name: platform.charAt(0).toUpperCase() + platform.slice(1),
        data: dailyData,
      });
    });

    console.log("📊 Fixed Bar Chart Series Data:", dailyMentions);
    return dailyMentions;
  };
  const adjustChartData = (platformData, totalMentions) => {
    if (!platformData || typeof platformData !== "object") {
      console.error("❌ Invalid platform data:", platformData);
      return;
    }
  
    // Calculate total used mentions from platforms (should be fetched from API)
    let usedMentions = Object.values(platformData).reduce((sum, value) => sum + value, 0);
    
    // Ensure the used mentions value is properly set from API
    usedMentions = Math.round(usedMentions); // Round the value for cleaner representation
  
    // Calculate remaining mentions (10 million - used mentions)
    let remainingMentions = totalMentions - usedMentions;
  
    // Ensure no negative remaining mentions
    remainingMentions = Math.max(remainingMentions, 0);
  
    // Update chart data with the correct used and remaining mentions
    setChartData({
      series: [usedMentions, remainingMentions], // Use the correct series values here
      options: {
        chart: { type: "donut" },
        labels: ["Used Mentions", "Remaining Mentions"],
        colors: ["#1DA1F2", "#FFD700"], // Blue for used mentions, gold for remaining
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total Mentions",
                  color: "#333",
                  fontSize: "16px",
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => formatNumber(val), // Use the formatNumber function to show values as K/M
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (val) => `${formatNumber(val)} Mentions`, // Proper tooltip for "Used Mentions"
          },
        },
      },
    });
  };
  
  


  const handleShowMentionsClick = async () => {
    if (!rightSidePlatform.length) {
      alert("❌ Please select at least one platform.");
      return;
    }
    if (!fromDate || !toDate) {
      alert("❌ Please select a valid date range.");
      return;
    }
  
    setIsLoading(true);
  
    try {
      const data = await fetchMentionsData(rightSidePlatform, fromDate, toDate);
      console.log("🔍 API Response:", data);
  
      if (data && data.total_mentions_all_platforms) {
        const totalMentions = 10000000; // 10 Million total mentions
        const usedMentions = Number(data.total_mentions_all_platforms) || 0; // Ensure it's a valid number
  
        const formattedUsedMentions = formatNumber(usedMentions); // Format for display
  
        const remainingMentions = totalMentions - usedMentions;
  
        // Update the donut chart with the calculated values
        adjustChartData(data.platform_totals, totalMentions);
  
        // Update the display values
        setUsedMentions(formattedUsedMentions);
        setTotalMentions(totalMentions); // Keep the raw total mentions value
  
        // Process the bar chart data and update the chart
        // const platforms = ["Twitter", "Instagram", "Facebook", "TikTok"];
        const seriesData = [
          { name: "Twitter", data: [data.platform_totals?.twitter ?? 0] },
          { name: "Instagram", data: [data.platform_totals?.instagram ?? 0] },
          { name: "Facebook", data: [data.platform_totals?.facebook ?? 0] },
          { name: "TikTok", data: [data.platform_totals?.tiktok ?? 0] },
        ];
  
        console.log("📊 Final Bar Chart Data:", seriesData);
  
        setBarChartData({
          series: seriesData,
          options: {
            chart: { type: "bar", height: 450 },
            plotOptions: { bar: { horizontal: false, columnWidth: "50%" } },
            xaxis: { categories: ["Total Mentions Per Platform"], title: { text: "Platforms" } },
            yaxis: { title: { text: "Mentions Count" }, min: 0 },
            colors: ["black", "#C13584", "#1877F2", "rgba(147, 0, 199, 0.9)"], // Platform colors
          },
        });
      } else {
        console.error("❌ No data found in the response.");
      }
    } catch (error) {
      console.error("❌ Error fetching mentions data:", error.response ? error.response.data : error);
    } finally {
      setIsLoading(false);
    }
  };
  


  return (
    <div className="admin-panel-wrapper">
      <div className="admin-main-container">
        {/* Left-Side Container */}
        <div className="left-side-container">
          <div className="admin-logs">
            <h3>Admin Logs</h3>
            <input
              type="text"
              placeholder="Search Logs"
              className="search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
<button
  className="fetch-logs-button"
  onClick={(e) => {
    e.stopPropagation(); // Prevent event bubbling
    fetchLogs();
  }}
  disabled={false} // Always enable the button
>
  <i className="fas fa-sync-alt"></i> {/* Remove the spinner logic */}
  Refresh Logs
</button>


<button className="download-button" onClick={(e) => {
  e.stopPropagation(); // Prevent event bubbling
  downloadLogs();
}}>
  <i className="fas fa-download"></i>
  {"  "}Download Logs (CSV)
</button>


            <div className="logs-table-container">
              <table className="logs-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Username</th>
                    <th>IP Address</th>
                    <th>Accessed Module</th>
                    <th>Action</th>
                    <th>Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  {currentLogs.length > 0 ? (
                    currentLogs.map((log) => (
                      <tr key={log.id}>
                        <td>{log.id}</td>
                        <td>{log.username}</td>
                        <td>{log.ip_address}</td>
                        <td>{log.accessed_module}</td>
                        <td>{log.action}</td>
                        <td>{new Date(log.timestamp).toLocaleString()}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No logs available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <div className="pagination">
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
        {/* Right-Side Container */}
        <div className="right-side-container">
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
  <h3 style={{ margin: 0 }}>Mentions Analysis</h3>
  <h3 style={{ margin: 0, color: '#800000' }}>Expiry Date: 31st March 2026</h3> {/* Soft Coral color */}
</div>





          {/* Platform Selection */}
          <div className="mentions-platform-selection">
  <label>Select Platforms:</label>
  <div className="mentions-platform-checkbox">
    <input
      type="checkbox"
      id="mentions-twitter"
      checked={rightSidePlatform.includes("Twitter")}
      onChange={(e) => handlePlatformChange(e, "Twitter")}
    />
    <label htmlFor="mentions-twitter" style={{ color: '#1DA1F2' }}>
      <FaTwitter style={{ marginRight: "8px", color: '#1DA1F2' }} /> Twitter
    </label>
  </div>

  <div className="mentions-platform-checkbox">
    <input
      type="checkbox"
      id="mentions-instagram"
      checked={rightSidePlatform.includes("Instagram")}
      onChange={(e) => handlePlatformChange(e, "Instagram")}
    />
    <label htmlFor="mentions-instagram" style={{ color: 'linear-gradient(45deg, #F58529, #D22F4B, #8A3AB9)' }}>
      <FaInstagram style={{ marginRight: "8px", color: '#E1306C' }} /> Instagram
    </label>
  </div>

  <div className="mentions-platform-checkbox">
    <input
      type="checkbox"
      id="mentions-facebook"
      checked={rightSidePlatform.includes("Facebook")}
      onChange={(e) => handlePlatformChange(e, "Facebook")}
    />
    <label htmlFor="mentions-facebook" style={{ color: '#1877F2' }}>
      <FaFacebook style={{ marginRight: "8px", color: '#1877F2' }} /> Facebook
    </label>
  </div>

  <div className="mentions-platform-checkbox">
    <input
      type="checkbox"
      id="mentions-tiktok"
      checked={rightSidePlatform.includes("TikTok")}
      onChange={(e) => handlePlatformChange(e, "TikTok")}
    />
    <label htmlFor="mentions-tiktok" style={{ color: '#FE2C55' }}>
      <BsTiktok style={{ marginRight: "8px", color: '#010101' }} /> TikTok
    </label>
  </div>
</div>

          {/* Date Filters */}
          <div className="date-filters">
            <label>From:</label>
            <input
              type="date"
              value={fromDate}
              onChange={handleFromDateChange}
              className="short-input"
            />
            <span className="formatted-date">{formatDate(fromDate)}</span>{" "}
            {/* Add class for styling */}
            <label>To:</label>
            <input
              type="date"
              value={toDate}
              onChange={handleToDateChange}
              className="short-input"
            />
            <span className="formatted-date">{formatDate(toDate)}</span>{" "}
            {/* Add class for styling */}
          </div>

          {/* Coin Type Selector
          <div className="coin-selector">
            <label>Select Coin Type:</label>
            <select
              value={selectedCoin}
              onChange={(e) => setSelectedCoin(e.target.value)}
            >
              <option value="xt">Coin 1</option>
              <option value="Fw3P">Coin 2</option>
              <option value="VoNl">Coin 3</option>
              <option value="W9jz">Coin 4</option>
            </select>
          </div> */}

          {/* Mentions Action Container */}
          <div className="mentions-action-container">
            {/* Mentions Counter */}
            <span className="mentions-counter"> Mentions: {"  "}
              {formatNumber(usedMentions)} / {formatNumber(totalMentions)}
            </span>

            {/* Coin Animation */}
            <img
              className="mentions-coin"
              id="mentionsCoin"
              src={coinImages[selectedCoin]}
              alt="Coin Animation"
            />

            {/* Button to Trigger Mentions */}
            <button
  className="btn show-mentions-btn"
  onClick={handleShowMentionsClick}
  disabled={isLoading}
>
  {/* Add the Font Awesome Icon with margin-right for spacing */}
  <i className={`fas fa-search`} style={{ marginRight: "8px" }}></i>
  {isLoading ? "Loading..." : "Show Mentions Used"}
</button>

            {/* Chart Display */}
            {/* Render the donut chart using ApexCharts */}
          </div>
          <div className="mention-chart">
          
            <ApexCharts
            
              options={chartData.options}
              series={chartData.series}
          
              type="donut"
              width="100%" // Adjusted width
              height="400" // Increased height
            />
          </div>
        </div>
      </div>
      <div className="bar-chart-container">
        <div className="bar-chart-card">
          <h2 className="bar-chart-title">Estimated Daily Use</h2>

          <ApexCharts
            options={barChartData.options}
            series={barChartData.series}
            type="bar"
            width={1200} // Make the chart expand better
            height={500} // Increased height for better readability
          />
        </div>
      </div>
    </div>
  );
};

export default AdminMainContainer;
